import React, { useState } from "react";

const SelectedImagesStrip = ({ images, onRemove, onRemoveAll, minImages, maxImages, onContinue }) => {
    const selectedImageCount = images.length;
    const [isAccordionOpen, setIsAccordionOpen] = useState(false);

    const toggleAccordion = () => {
        setIsAccordionOpen(!isAccordionOpen);
    };

    return (
        <div className="selected-images-strip">
            <div className="selected-images-strip__header">
                <p>Please select a minimum of 5 images, and a maximum of 10.</p>

                <p id="remove-images-text">
                    <i>{selectedImageCount > 0 ? `Click images to remove.` : ""}</i>
                </p>
            </div>
            <button className="accordion-toggle" onClick={toggleAccordion}>
                {isAccordionOpen ? "Hide Images" : "Show Images"}
            </button>
            <div className={`selected-images-strip__container ${isAccordionOpen ? "is-open" : ""}`}>
                <p id="remove-images-text">
                    <i>{selectedImageCount > 0 ? `Tap images to remove.` : ""}</i>
                </p>
                {images.map((url, index) => (
                    <div className="selected-image" onClick={() => onRemove(index)}>
                        <img key={index} src={url} alt={`Selected Image ${index}`} crossOrigin="anonymous" />
                    </div>
                ))}
                {selectedImageCount > 0 && (
                    <button className="remove-all-button" onClick={onRemoveAll}>
                        Remove All
                    </button>
                )}
            </div>
            <div className="selected-images-strip__footer">
                {selectedImageCount > 0 && (
                    <button className="remove-all-button" onClick={onRemoveAll}>
                        Remove All
                    </button>
                )}
                <button className="continue-button" onClick={onContinue} disabled={selectedImageCount < minImages}>
                    {selectedImageCount < minImages ? `Select ${minImages - selectedImageCount} more` : "Continue"}
                </button>
            </div>
        </div>
    );
};

export default SelectedImagesStrip;
